module.exports = __webpack_public_path__ + "img/ad.42cf60af.png";